import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Link,
  Typography,
  useTheme,
} from "@material-ui/core";
import ChevronRightIcon from "../../icons/ChevronRight";
import { Link as RouterLink } from "react-router-dom";
import { FC, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { IColumn } from "src/components/dataTable/tableModel";
import DataTable from "src/components/dataTable/dataTable";
import { IUserGroupData } from "./Types/MobileUserGroup";
import { GetMobileRoleCodeMaster, GetMobileUserGroups } from "./ConnectionService";
import MobileUserGroupCreateEditModal from "./MobileUserGroupCreateEditModal";
import AlertMessage from "src/components/ui-components/AlertMessage";

const MobileUserGroups: FC = () => {
  const theme = useTheme();
  const [mobileUserGroupsData, setMobileUserGroupsData] = useState<IUserGroupData[]>([]);
  const [showCreateEditModal, setShowCreateEditModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedUserGroupKey, setSelectedUserGroupKey] = useState<string | null>(null);
  const [mobileRoleCodeMaster, setMobileRoleCodeMaster] = useState<any[]>([]);
  const isMountedRef = useRef(true);

  const columns: IColumn[] = [
    {
      field: "userGroup",
      headerName: "User Group"
    },
    {
      field: "ClientRole",
      headerName: "Role"
    },
    {
      field: "parentUserGroupName",
      headerName: "Parent Role",
    },
    {
      field: "MobileRoleCode",
      headerName: "Mobile Role Code",
    },
  ];
  const getMobileUserGroups = async () => {
    setIsLoading(true);
    let res = await GetMobileUserGroups();
    res = res.map((x) => {
      if (x.ParentUserGroup) {
        const parentGroup = res.find(
          (y) => y.UserGroupKey === x.ParentUserGroup
        );
        if (parentGroup) {
          x.parentUserGroupName = parentGroup.userGroup;
        }
      }
      return x;
    });
    setMobileUserGroupsData(res);
    setIsLoading(false);
  };

  const getMobileRoleCodeMaster = async () => {
    try {
      GetMobileRoleCodeMaster().then((res) => {
        setMobileRoleCodeMaster(res);
      });
    } catch (err) {
      AlertMessage({ type: "error", msg: err.title });
    }
  };

  useEffect(() => {
    getMobileUserGroups();
    getMobileRoleCodeMaster();

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleEditClick = (clickedUserGroup) => {
    setSelectedUserGroupKey(clickedUserGroup.UserGroupKey);
    setShowCreateEditModal(true);
  };


  return (
    <>
      <Helmet>
        <title>Mobile User Groups</title>
      </Helmet>
      <Box>
        <Container maxWidth={false}>
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 1100,
              opacity: 1,
              width: "100%",
              py: 1,
              backgroundColor: theme.palette.background.default,
            }}
          >
            <Grid alignItems="center" container justifyContent="space-between">
              <Grid item>
                <Breadcrumbs
                  aria-label="breadcrumb"
                  separator={<ChevronRightIcon fontSize="small" />}
                >
                  <Link
                    color="textPrimary"
                    component={RouterLink}
                    to=""
                    variant="h5"
                  >
                    Configurations
                  </Link>
                  <Typography color="textPrimary" variant="h5">
                    Mobile User Groups
                  </Typography>
                </Breadcrumbs>
              </Grid>
              <Grid item>
                <Box sx={{ my: 1 }}>
                  <Button
                    sx={{
                      background:
                        "linear-gradient(to bottom, #072f40, #072f40)",
                    }}
                    variant="contained"
                    onClick={() => {
                      setShowCreateEditModal(true);
                    }}
                  >
                    Create New
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Grid container spacing={2} style={{ flex: 1 }}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <Card>
                <CardContent>
                  <DataTable
                    columns={columns}
                    dataList={mobileUserGroupsData}
                    isLoading={isLoading}
                    onClickEdit={handleEditClick}
                    infoText=""
                    showActionsHeader
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <MobileUserGroupCreateEditModal
        open={showCreateEditModal}
        handleClose={() => {
          setShowCreateEditModal(false);
          setSelectedUserGroupKey(null);
        }}
        userGroupKey={selectedUserGroupKey}
        mobileUserGroupList={mobileUserGroupsData}
        refreshData={getMobileUserGroups}
        mobileRoleCodeMaster={mobileRoleCodeMaster}
      />
    </>
  );
};

export default MobileUserGroups;
